import { configApi, variantsApi } from '~/shared/api'
import { getAppConfigFromConfigRaw } from '~/shared/helpers/getAppConfigFromConfigRaw'
import { getVariantFromRawVariant } from '~/shared/helpers/getVariantFromRawVariant'

import { GET_APP_CONFIG, GET_VARIANT } from '../actionTypes'
import {
  setAppConfigAction,
  setVariantAction,
  startFetching,
  stopFetching,
} from './syncActions'

export function getVariantAction({ cohort }: { cohort: string }): any {
  return async (dispatch) => {
    dispatch(startFetching(GET_VARIANT))

    const response = await variantsApi.getVariant({ cohort })

    if (response.success && response.data) {
      const variant = getVariantFromRawVariant(response.data.variant)

      dispatch(setVariantAction(variant))
    }

    dispatch(stopFetching(GET_VARIANT))
  }
}

export function getAppConfigAction(): any {
  return async (dispatch) => {
    dispatch(startFetching(GET_APP_CONFIG))

    const response = await configApi.getAppConfig()

    if (response.success && response.data) {
      const config = getAppConfigFromConfigRaw(response.data.config)
      dispatch(setAppConfigAction(config))
    }

    dispatch(stopFetching(GET_APP_CONFIG))
  }
}
